import React from "react";
import { Typography, Container } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Resume from "../../settings/resume.json";

const useStyles = makeStyles((theme) => ({
  main: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "flex-start",
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(6),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up("md")]: {
      paddingLeft: theme.spacing(6),
    },
  },
  greeting: {
    fontFamily: "Roboto Mono, monospace",
    color: theme.palette.primary.main,
    letterSpacing: "0.25rem",
    textTransform: "uppercase",
    fontSize: "0.9rem",
    marginBottom: theme.spacing(1),
  },
  name: {
    fontWeight: 700,
    lineHeight: 1.05,
    color: "#F5F7FA",
    textShadow: "0 2px 18px rgba(0,0,0,0.45)",
    fontSize: "2.6rem",
    [theme.breakpoints.up("md")]: {
      fontSize: "4rem",
    },
  },
  job: {
    fontWeight: 700,
    lineHeight: 1.1,
    marginTop: theme.spacing(1),
    fontSize: "2.2rem",
    background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    [theme.breakpoints.up("md")]: {
      fontSize: "3.4rem",
    },
  },
  summary: {
    marginTop: theme.spacing(3),
    maxWidth: 620,
    color: "rgba(245,247,250,0.85)",
    lineHeight: 1.7,
    fontSize: "1rem",
    textShadow: "0 1px 12px rgba(0,0,0,0.4)",
  },
}));

export const Content = () => {
  const classes = useStyles();

  return (
    <Container component="main" className={classes.main} maxWidth="lg">
      <Typography className={classes.greeting}>
        {Resume.basics.x_title}
      </Typography>
      <Typography variant="h1" component="h1" className={classes.name}>
        {Resume.basics.name}
      </Typography>
      <Typography variant="h2" component="h2" className={classes.job}>
        {`${Resume.basics.job1} ${Resume.basics.job2}`}
      </Typography>
      <Typography className={classes.summary}>
        {Resume.basics.description}
      </Typography>
    </Container>
  );
};
